import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [String, Boolean, Array]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: String
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.modelProps,
      options: this.config.datasource.options ? this.config.datasource.options : []
    }
  },
  created () {},
  watch: {
    value (newValue, oldValue) {
      if(this.config.chooseOne && this.config.typeGroup !== 'radio' && newValue.length > 1) {
        this.value = this._.difference(newValue, oldValue)
      }
      this.$emit('input', this.value)
    }
  },
  computed: {
    validationRules () {
      return this.expressionResolver(this.config.validation)
    }
  },
  methods: {
    onBlur () {}
  }
}
